export const RECURRING_REQUEST_INTERVAL_MILLISECONDS = 30 * 1000;
export const TIMEOUT_TO_START_TOKEN_REFRESH_SECONDS = 2 * 60;
